import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing';
import AboutUsPage from './pages/about-us-page';
import PricingPage from './pages/pricing-page';
import TeamPerformanceHub from './pages/team-performance-hub';
import ComplianceDashboard from './pages/compliance-dashboard';
import IPMOperationsOverview from './pages/ipm-operations-overview';
import TreatmentAnalytics from './pages/treatment-analytics';
import ProductBrowser from './pages/product-browser';
import ApplicationLogs from './pages/application-logs';
import PremiumCalculatorSuite from './pages/premium-calculator-suite';
import LoginPage from './pages/login';
import TaskManagement from './pages/task-management';
import IPMLearningCenter from './pages/ipm-learning-center';
import AiChatAssistant from "./pages/ai-chat-assistant";
import PrivacyPolicyPage from "pages/privacy-policy";
import TermsConditionsPage from "pages/terms-conditions";
import UserSettingsPreferences from "pages/user-settings-preferences";
import AdminDashboard from './pages/admin-dashboard';
import AuditLogDashboard from './pages/audit-log-dashboard';
import AIPoweredStrategicAnalyticsDashboard from 'pages/ai-powered-strategic-analytics-dashboard';
import UnifiedNotificationCenter from './pages/unified-notification-center';
import SMSAlertDashboard from './pages/sms-alert-dashboard';
import SupervisorAlertManagementDashboard from './pages/supervisor-alert-management-dashboard';
import PredictiveAnalyticsDashboard from './pages/predictive-analytics-dashboard';

import EscalationRulesManagement from './pages/escalation-rules-management';
import AutomatedWorkflowBuilder from './pages/automated-workflow-builder';
import PreviewTreatmentAnalytics from './pages/preview-treatment-analytics';
import PreviewTeamPerformance from './pages/preview-team-performance';
import PreviewCalculators from './pages/preview-calculators';
import PreviewNotifications from './pages/preview-notifications';
import PreviewAuditLogs from './pages/preview-audit-logs';
import ClientPortalDashboard from './pages/client-portal-dashboard';
import EmailVerificationScreen from './pages/email-verification-screen';
import SmsVerificationScreen from './pages/sms-verification-screen';

import { useNavigationInit } from './services/navigationService';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';

// Navigation initializer component
const NavigationInit = ({ children }) => {
  useNavigationInit();
  return children;
};

// Google Analytics initializer component
const AnalyticsInit = ({ children }) => {
  useGoogleAnalytics();
  return children;
};

export default function ProjectRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/about-us-page" element={<AboutUsPage />} />
          <Route path="/pricing-page" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/team-performance-hub" element={<TeamPerformanceHub />} />
          <Route path="/compliance-dashboard" element={<ComplianceDashboard />} />
          <Route path="/ipm-operations-overview" element={<IPMOperationsOverview />} />
          <Route path="/treatment-analytics" element={<TreatmentAnalytics />} />
          <Route path="/product-browser" element={<ProductBrowser />} />
          <Route path="/application-logs" element={<ApplicationLogs />} />
          <Route path="/premium-calculator-suite" element={<PremiumCalculatorSuite />} />
          <Route path="/task-management" element={<TaskManagement />} />
          <Route path="/ipm-learning-center" element={<IPMLearningCenter />} />
          <Route path="/ai-chat-assistant" element={<AiChatAssistant />} />
          
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/audit-log-dashboard" element={<AuditLogDashboard />} />
          
          <Route path="/ai-powered-strategic-analytics-dashboard" element={<AIPoweredStrategicAnalyticsDashboard />} />
          
          <Route path="/unified-notification-center" element={<UnifiedNotificationCenter />} />
          <Route path="/sms-alerts" element={<SMSAlertDashboard />} />
          <Route path="/supervisor-alert-management-dashboard" element={<SupervisorAlertManagementDashboard />} />
          <Route path="/predictive-analytics-dashboard" element={<PredictiveAnalyticsDashboard />} />
          <Route path="/escalation-rules" element={<EscalationRulesManagement />} />
          <Route path="/automated-workflow-builder" element={<AutomatedWorkflowBuilder />} />
          <Route path="/client-portal-dashboard" element={<ClientPortalDashboard />} />
          <Route path="/email-verification-screen" element={<EmailVerificationScreen />} />
          <Route path="/sms-verification-screen" element={<SmsVerificationScreen />} />
          
          {/* Preview/Demo Routes for Non-Authenticated Users */}
          <Route path="/preview/treatment-analytics" element={<PreviewTreatmentAnalytics />} />
          <Route path="/preview/team-performance" element={<PreviewTeamPerformance />} />
          <Route path="/preview/calculators" element={<PreviewCalculators />} />
          <Route path="/preview/notifications" element={<PreviewNotifications />} />
          <Route path="/preview/audit-logs" element={<PreviewAuditLogs />} />
          
          {/* Legal Pages - Public Access with multiple path variants */}
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsConditionsPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/user-settings-preferences" element={<UserSettingsPreferences />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}